import { RefObject, useEffect, useState } from 'react';

/* Hides the bars once the user has scrolled past `threshold` px and is scrolling down;
   shows them again as soon as the user scrolls up, or is back near the top. */
const threshold = 8;

export default function useHideOnScroll(ref: RefObject<HTMLElement | null>) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let lastScrollTop = el.scrollTop;
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const { scrollTop } = el;
        const delta = scrollTop - lastScrollTop;

        if (scrollTop <= threshold) {
          setHidden(false);
        } else if (delta > threshold) {
          setHidden(true);
        } else if (delta < -threshold) {
          setHidden(false);
        }

        lastScrollTop = scrollTop;
        ticking = false;
      });
    };

    el.addEventListener('scroll', handleScroll, { passive: true });
    return () => el.removeEventListener('scroll', handleScroll);
  }, [ref]);

  return hidden;
}
